import React from 'react';
import { ExternalLink } from 'lucide-react';

const LinkPreview = ({ preview }) => {
    const { url, domain, title, description, image } = preview;

    if (!title && !description && !image) {
        return null;
    }

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 block max-w-lg border border-gray-200 rounded-lg overflow-hidden hover:border-gray-300 hover:shadow-md transition-all bg-white"
        >
            {image && (
                <div className="w-full h-48 bg-gray-100 overflow-hidden">
                    <img
                        src={image}
                        alt={title || domain}
                        className="w-full h-full object-cover"
                        loading="lazy"
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </div>
            )}
            <div className="p-3">
                <div className="flex items-start justify-between gap-2 mb-1">
                    <h4 className="font-semibold text-sm text-gray-900 line-clamp-2">
                        {title}
                    </h4>
                    <ExternalLink className="w-4 h-4 text-gray-400 flex-shrink-0" />
                </div>
                {description && (
                    <p className="text-sm text-gray-600 line-clamp-2 mb-2">
                        {description}
                    </p>
                )}
                <p className="text-xs text-gray-400 truncate">
                    {domain}
                </p>
            </div>
        </a>
    );
};

export default LinkPreview;
